










































































import Vue from 'vue'
import axios from 'axios'
import TitleName from '../atoms/TitleName.vue'
import ModalPanel from '../atoms/ModalPanel.vue'
import SubmitFlow from '../organisms/SubmitFlow.vue'
import ExmasForTensakuVisiter from '../../utils/ExmasForTensakuVisiter'
import { examInfo } from '../../utils/ExmasForTensakuVisiter/type'

export type DataType = {
  examInfo?: examInfo,
  loginId: string,
  password: string,
  errorMessage: string,
}
export default Vue.extend({
  components: {
    TitleName,
    ModalPanel,
    SubmitFlow
  },
  data(): DataType {
    return {
      examInfo: undefined,
      loginId: '',
      password: '',
      errorMessage: ''
    }
  },
  mounted() {
    this.$store.dispatch('getCurrentDate')
    this.$store.commit('user/logout')
  },
  async created() {
    // サーバ側の現在時刻を取得
    this.$store.dispatch('getCurrentDate')
    // 試験IDを取得
    this.$store.commit('SET_EXAM_INFO', { examInfo: null })
    const examKey = this.$route.params['exam_id']
    if (Object.keys(ExmasForTensakuVisiter).includes(examKey)) {
      this.examInfo = ExmasForTensakuVisiter[examKey]
    }
  },
  computed: {
    lostPasswordUrl(): string {
      return `${process.env.VUE_APP_ROOT_PATH}/participant/forgot-id-or-password`
    },
    questionPageUrl(): string {
      return `${process.env.VUE_APP_ROOT_PATH}/participant/faq/`
    },
    questionPageUrlForTensakuVisiter(): string {
      return `/tensaku_visiter/faq/${this.examInfo?.examGroupKey}`
    },
    isOverPeriod(): boolean {
      if (!this.examInfo?.endTo) {
        return false
      }
      return new Date(this.examInfo?.endTo) < new Date(this.$store.state.currentDate)
    }
  },
  methods: {
    async signIn() {
      let res = null
      try {
        res = await axios.post('/api/v1/auth/sign_in', {
          email: this.loginId,
          password: this.password,
          exam_id: this.examInfo?.examGroupKey,
        })
      } catch(e) {
        // 401 etc
      }
      if (!res || res.data.success == false) {
        return this.errorMessage = 'ログインに失敗しました。メールアドレスとパスワードを確認してください。'
      }
      // 成功時の処理
      this.$store.dispatch('saveSubmitTestVisiterAuth', { response: res })

      this.$router.push('/tensaku_visiter/')

    }
  }
})
